export const EMBEDDABLE_PATHS = ['/inside-ai-coding/embed'] as const;

/**
 * Returns true when `pathname` matches an embeddable path or one of its
 * subpaths (per-chart embeds live at /inside-ai-coding/embed/[id]).
 */
export function isEmbeddablePath(pathname: string): boolean {
  return EMBEDDABLE_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}
